import React from 'react';
import { createPortal } from 'react-dom';

const ScModal = ({ open, title, onClose, children, footer, size }) => {
  if (!open) return null;
  const modalClass = size === 'lg' ? 'sc-modal sc-modal-lg' : 'sc-modal';
  return createPortal(
    <div className="sc-modal-overlay" onClick={onClose} role="presentation">
      <div className={modalClass} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="sc-modal-header">
          <h3>{title}</h3>
          <button type="button" className="sc-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="sc-modal-body">{children}</div>
        {footer && <div className="sc-modal-footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );
};

export default ScModal;
